import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsAddressViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map